/**
 * Welke werkruimte er in beeld is (MA-72). Dat volgt uit het pad: alles onder
 * `/sportcity` is SportCity, de rest Huizen. Zo is er niets om bij te houden, en
 * een link naar een scherm neemt zijn werkruimte vanzelf mee.
 *
 * Welke er bij het openen komt, onthoudt de browser: de laatst gekozen, als het
 * account er nog in zit, anders de eerste die het heeft.
 */
import type { Werkruimte } from '@mamimap/shared';
import { ROUTES } from './router';

const SLEUTEL = 'mamimap:werkruimte';

export function werkruimteVanPad(pad: string): Werkruimte {
  return pad === ROUTES.sportcity || pad.startsWith(`${ROUTES.sportcity}/`)
    ? 'sportcity'
    : 'huizen';
}

/** Het scherm waar een werkruimte opengaat. */
export function startpad(werkruimte: Werkruimte): string {
  return werkruimte === 'sportcity' ? ROUTES.sportcity : ROUTES.kaart;
}

/** Instellingen en inloggen horen bij geen van beide: die mag elk account zien. */
export function isGedeeldPad(pad: string): boolean {
  return pad === ROUTES.instellingen || pad === ROUTES.inloggen;
}

export function onthoudWerkruimte(werkruimte: Werkruimte): void {
  try {
    window.localStorage.setItem(SLEUTEL, werkruimte);
  } catch {
    // Geen opslag (privévenster): dan begint het account in zijn eerste werkruimte.
  }
}

/** De werkruimte om in te beginnen: de laatst gekozen als die mag, anders de eerste. */
export function voorkeurWerkruimte(werkruimtes: readonly Werkruimte[]): Werkruimte | null {
  let laatst: string | null = null;
  try {
    laatst = window.localStorage.getItem(SLEUTEL);
  } catch {
    laatst = null;
  }
  const gevonden = werkruimtes.find((werkruimte) => werkruimte === laatst);
  return gevonden ?? werkruimtes[0] ?? null;
}
